interface TradeResult {
  count: number;
  returnPer: number;
  returnAfter: number;
}

interface AggregatedResult {
  [key: string]: TradeResult;
}

export const getModalReturns = (models_arr: any) => {

  let codeArr: any = [];
  const result: AggregatedResult | undefined = models_arr?.reduce(
    (acc: AggregatedResult, trade: any) => {
      const { s_code, n_return, n_return_after_cost, oneDay_return_per, n_parallel_return, n_parallel_return_after_cost } = trade;
      codeArr.push(s_code)
      if (!acc[s_code]) {
        acc[s_code] = {
          count: 0,
          returnPer: 0,
          returnAfter: 0,
        };
      }
      if (s_code?.slice(1, 3) === 'ES'|| s_code?.slice(0, 3) === 'QEB') {
        acc[s_code].count++;
        acc[s_code].returnPer += parseFloat(Number(oneDay_return_per)?.toFixed(4));
        acc[s_code].returnAfter += parseFloat(Number(oneDay_return_per)?.toFixed(4));
        return acc;
      }
      else {
        acc[s_code].count++;
        acc[s_code].returnPer += (s_code?.slice(0, -1) === 'AIONIFMMI') ? Number(n_parallel_return) : Number(n_return)
        acc[s_code].returnAfter += (s_code?.slice(0, -1) === 'AIONIFMMI') ? Number(n_parallel_return_after_cost) : Number(n_return_after_cost);
        return acc;
      }
    },
    {}
  );
  if (!result) {
    return []; // Return empty array if result is undefined
  }

  // Convert result object to the desired format
  const finalResult: { [key: string]: TradeResult }[] = Object.entries(result).map(([s_code, values]) => {
    return { [s_code]: { count: values.count, returnPer: values.returnPer, returnAfter: values.returnAfter, } }
  });

  // Sort final result based on returnPer
  finalResult.sort((a, b) => {
    const keyA:any = Object.values(a)[0].returnPer;
    const keyB:any = Object.values(b)[0].returnPer;
    return keyB - keyA;
  });
  return finalResult;
};

export const backDatedGetModalReturns = (models_arr: any) => {
  const result: AggregatedResult | undefined = models_arr.reduce(
    (acc: AggregatedResult, trade: any) => {
      const { identifier, return_per, return_after_cost, oneDay_return_per, n_parallel_return, n_parallel_return_after_cost } = trade;

      if (!acc[identifier]) {
        acc[identifier] = {
          count: 0,
          returnPer: 0,
          returnAfter: 0,
        };
      }
      if ((identifier?.slice(1, 3) === 'ES') || (identifier?.slice(1, 3) === 'EB')) {
        acc[identifier].count++;
        acc[identifier].returnPer += parseFloat(oneDay_return_per);
        acc[identifier].returnAfter += parseFloat(oneDay_return_per);
        return acc;
      }
      else {
        acc[identifier].count++;
        acc[identifier].returnPer += (identifier?.slice(0, -1) === 'AIONIFMMI') ? (n_parallel_return) : (return_per);
        acc[identifier].returnAfter += (identifier?.slice(0, -1) === 'AIONIFMMI') ? Number(n_parallel_return_after_cost) : (return_after_cost);
        return acc;
      }
    },
    {}
  );

  if (!result) {
    return []; // Return empty array if result is undefined
  }
  // Convert result object to the desired format
  const finalResult: { [key: string]: TradeResult }[] = Object.entries(result).map(([identifier, values]) => ({
    [identifier]: {
      count: values.count,
      returnPer: Number(values.returnPer),
      returnAfter: Number(values.returnAfter),
    },
  }));
  // Sort final result based on returnPer
  finalResult.sort((a, b) => {
    const keyA: any = Object.values(a)[0].returnPer;
    const keyB: any = Object.values(b)[0].returnPer;
    return keyB - keyA;
  });

  return finalResult;
};


